import React, { createContext, useContext, useState } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [username, setUsername] = useState(() => localStorage.getItem('username') || '');
  const [userEmail, setUserEmail] = useState(() => localStorage.getItem('userEmail') || '');

  const login = (uname, email) => {
    setUsername(uname);
    setUserEmail(email || '');
    localStorage.setItem('username', uname);
    if (email) localStorage.setItem('userEmail', email);
  };

  const logout = () => {
    setUsername('');
    setUserEmail('');
    // Preserve all per-user profile photos across logout
    const preserved = {};
    Object.keys(localStorage).forEach(k => {
      if (k.startsWith('profile_photo_')) preserved[k] = localStorage.getItem(k);
    });
    localStorage.clear();
    Object.entries(preserved).forEach(([k, v]) => localStorage.setItem(k, v));
  };

  return (
    <AuthContext.Provider value={{ username, userEmail, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}